export const WORKFLOW_STATE = {
  UNASSIGNED: 'Unassigned'
};

export const WORKFLOW_STATE_TRANSITION = {
  ASSIGN: 'Assign'
};
